import React, { useState, useEffect } from "react";
import { isMobile } from 'react-device-detect';
import { useAuth } from '../../context/auth';
import { GoToDoveMed } from '../GoToDoveMed';
import { MobileToolbar } from './MobileToolbar/MobileToolbar';
import { DesktopToolbar } from './DesktopToolbar/DesktopToolbar';
import { StyledAppBar } from './AppBar.styles';
import { VerificationBanner } from './VerificationBanner';

export function AppBar() {
  const { user } = useAuth();

  const [verticalAxis, setVerticalAxis] = useState(0);
  const [isDovemedLinkHidden, hideDovemedLink] = useState(false);

  const handleScroll = () => {
    setVerticalAxis(window.scrollY);
    (window.scrollY > verticalAxis) ? hideDovemedLink(true) : hideDovemedLink(false);
    (window.scrollY < 0 || verticalAxis < 0) && hideDovemedLink(false);
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  })
  return (
    <StyledAppBar position="fixed">
      {!isDovemedLinkHidden &&
        <GoToDoveMed />
      }
      {isMobile ?
        <MobileToolbar /> :
        <DesktopToolbar />
      }
      {(user && !user.verifiedAccount) &&
        <VerificationBanner />
      }
    </StyledAppBar>
  );
}
